import { NumberType } from '@flipster/react/design-utils/formatted';
import { ColorToken } from '@flipster/styled-system/tokens';
import Num from '@flipster/utils/num';

export const getNumberColorWithNegativeWhite = (value: NumberType): ColorToken => {
  const isPositive = Num(value ?? '0').gt(0);
  return isPositive ? 'content.state.positive' : 'content.default.level-5';
};
